import { createContext } from 'react';
const ElementContext = /*#__PURE__*/createContext({
  elementHtml: ''
});
export default ElementContext;